import React from 'react';
import ReportHeader from '../../components/reports/shared/report-header';
import NewHireCoachingValuesFitMisaligned from '../../components/reports/new-hire-coaching-report/new-hire-coaching-values-fit-misaligned';
import NewHireCoachingValuesAligned from '../../components/reports/new-hire-coaching-report/new-hire-coaching-values-fit-aligned';
import { NEW_HIRE_VALUE_TIPS } from '../../components/reports/shared/tips/acumen-values-experience-tips';
import ExperienceJudgmentResults from '../../components/reports/shared/results/experience-judgment-results';
import RecommendationsPersonalityTips from '../../components/reports/shared/tips/recommendations-personality-tips';
import CompetenciesJudgmentTips from '../../components/reports/shared/tips/competencies-judgment-tips';
import ReportPdfHeader from '../../components/reports/shared/report-pdf-header';
import CandidateReportSummary from '../../components/reports/candidate/candidate-report-summary';
import { MAX_VALUES } from '../../components/reports/shared/report-util';
import PagedAcumenValuesExperienceTips from '../../components/reports/shared/tips/paged-acumen-values-experience-tips';
import CandidateInterviewSummary from '../../components/reports/candidate-profile/candidate-interview-summary';
import CoachingPersonalityPage1 from '../../components/reports/shared/results/coaching-personality-page-1';
import CoachingPersonalityPage2 from '../../components/reports/shared/results/coaching-personality-page-2';
import CandidateConfidentialPage from '../../components/reports/candidate/candidate-confidential-page';
import CandidateExecutiveSummary from '../../components/reports/candidate/candidate-executive-summary';
import { REPORT_TYPE } from '../../utils/constants';
import { FeedbackReport } from '../../components/reports/shared/results/feedback-report';

function NewHireCoachingReport({ candidate, creatingPdf, reportType = REPORT_TYPE.coaching }) {
  return (
    <>
      <div className="print-page">
        <CandidateConfidentialPage candidate={candidate} competencies={true} />
      </div>
      <div className="print-page print-heading">
        <ReportPdfHeader />
        <ReportHeader candidate={candidate} header="New Hire Coaching Report" />
        <CandidateReportSummary
          candidate={candidate}
          withAssessmentText={true}
          withRecommendationSummary={reportType === REPORT_TYPE.coaching}
        />
      </div>
      <FeedbackReport candidate={candidate} reportType={REPORT_TYPE.coaching} creatingPdf={creatingPdf} />
      {candidate.interviewCompetencies?.comments && (
        <div className="print-page">
          <CandidateExecutiveSummary comments={candidate.interviewCompetencies.comments} />
        </div>
      )}
      <div className="print-page">
        <CoachingPersonalityPage1 candidate={candidate} reportType={REPORT_TYPE.coaching} />
      </div>
      <div className="print-page">
        <CoachingPersonalityPage2 candidate={candidate} reportType={REPORT_TYPE.coaching} />
      </div>
      <div className="print-page">
        <NewHireCoachingValuesFitMisaligned candidate={candidate} start={0} max={creatingPdf ? 10 : MAX_VALUES} />
      </div>
      {creatingPdf && (
        <div className="print-page">
          <NewHireCoachingValuesFitMisaligned candidate={candidate} start={10} max={MAX_VALUES} />
        </div>
      )}
      <div className="print-page">
        <NewHireCoachingValuesAligned candidate={candidate} start={0} max={creatingPdf ? 10 : MAX_VALUES} />
      </div>
      {creatingPdf && (
        <div className="print-page">
          <NewHireCoachingValuesAligned candidate={candidate} start={10} max={MAX_VALUES} />
        </div>
      )}
      <div className="print-page">
        <ExperienceJudgmentResults candidate={candidate} />
      </div>
      {candidate.interviewCompetencies?.scores && (
        <div className="print-page">
          <CandidateInterviewSummary candidate={candidate} />
        </div>
      )}
      <div className="print-page">
        <RecommendationsPersonalityTips candidate={candidate} nTips={2} />
      </div>
      <PagedAcumenValuesExperienceTips
        candidate={candidate}
        valuesTips={NEW_HIRE_VALUE_TIPS}
        creatingPdf={creatingPdf}
      />
      <div className="print-page">
        <CompetenciesJudgmentTips candidate={candidate} nTips={2} />
      </div>
    </>
  );
}

export default NewHireCoachingReport;
